import { useRef, useState } from "react";
import classNames from "classnames";
import useDarkMode from "../../hooks/useDarkMode";
import Button, { ButtonGroup } from "../bootstrap/Button";
import PageWrapper from "../../layout/PageWrapper/PageWrapper";
import Page from "../../layout/Page/Page";
import Card, { CardActions, CardBody, CardFooter, CardFooterRight, CardHeader, CardLabel, CardTitle } from "../bootstrap/Card";
import Icon from "../icon/Icon";
import Input from "../bootstrap/forms/Input";
import FormGroup from "../bootstrap/forms/FormGroup";
import Checks, { ChecksGroup } from "../bootstrap/forms/Checks";
import OffCanvas, { OffCanvasBody, OffCanvasHeader, OffCanvasTitle } from "../bootstrap/OffCanvas";
import { useFormik } from "formik";
import Badge from '../bootstrap/Badge';
import Alert from "../bootstrap/Alert";
import Avatar from "../Avatar";
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from "../bootstrap/Dropdown";
import Textarea from "../bootstrap/forms/Textarea";
import Modal, { ModalBody, ModalHeader, ModalTitle } from "../bootstrap/Modal";
import { useNavigate, useParams } from "react-router-dom";
import Select from "../bootstrap/forms/Select";
import Tooltips from "../bootstrap/Tooltips";

const emailPreferences = () => {
    let { text } = useParams()

    const navigate = useNavigate();

    const employeePortalForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            fromDate: '',
            name: '',
            email: '',
        },
        validate: (values) => {
            const errors: {
                fromDate?: string;
                name?: string;
                email?: string;
            } = {};

            if (!values.fromDate) {
                errors.fromDate = '';
            }
            if (!values.name) {
                errors.name = 'Required';
            }
            if (!values.email) {
                errors.email = 'Required';
            }
            return errors;
        },
        validateOnChange: false,
        onSubmit: () => { },
    });
    const editEmployeePortalForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            fromDate: '',
            name: '',
            email: '',
            userName:'',
            emailId:'',
        },
        validate: (values) => {
            const errors: {
                fromDate?: string;
                name?: string;
                email?: string;
            } = {};

            if (!values.fromDate) {
                errors.fromDate = '';
            }
            if (!values.name) {
                errors.name = 'Required';
            }
            if (!values.email) {
                errors.email = 'Required';
            }
            return errors;
        },
        validateOnChange: false,
        onSubmit: () => { },
    });

    const iTDeclarationForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            fromDate: '',
            name: '',
            email: '',
        },
        validate: (values) => {
            const errors: {
                fromDate?: string;
                name?: string;
                email?: string;
            } = {};

            if (!values.fromDate) {
                errors.fromDate = '';
            }
            if (!values.name) {
                errors.name = 'Required';
            }
            if (!values.email) {
                errors.email = 'Required';
            }
            return errors;
        },
        validateOnChange: false,
        onSubmit: () => { },
    });
    const investmentForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            fromDate: '',
            name: '',
            email: '',
        },
        validate: (values) => {
            const errors: {
                fromDate?: string;
                name?: string;
                email?: string;
            } = {};

            if (!values.fromDate) {
                errors.fromDate = '';
            }
            if (!values.name) {
                errors.name = 'Required';
            }
            if (!values.email) {
                errors.email = 'Required';
            }
            return errors;
        },
        validateOnChange: false,
        onSubmit: () => { },
    });
    const senderEmailForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            fromDate: '',
            name: '',
            email: '',
        },
        validate: (values) => {
            const errors: {
                fromDate?: string;
                name?: string;
                email?: string;
            } = {};

            if (!values.fromDate) {
                errors.fromDate = '';
            }
            if (!values.name) {
                errors.name = 'Required';
            }
            if (!values.email) {
                errors.email = 'Required';
            }
            return errors;
        },
        validateOnChange: false,
        onSubmit: () => { },
    });

    const [manageContactsOpen, setManageContactsOpen] = useState(false);
    const [view, setView] = useState(false);
    const { themeStatus, darkModeStatus } = useDarkMode();
    const [handleEdit, setHandleEdit] = useState(false);
    const [contactEdit, setContactEdit] = useState(false);
    const [itDeclaration, setItDeclaration] = useState(false);
    const [poiPreference, setPoiPreference] = useState(false);
    const [emailContentOpen, setEmailContentOpen] = useState(false);
    const [emailPreference, setEmailPreference] = useState(false);
    const [addSender, setAddSender] = useState(false);
    const [onChange, setOnChange] = useState(false);
    const [radioButtonChecked, setRadioButtonChecked] = useState(false);
    const [radioButtonChecked1, setRadioButtonChecked1] = useState('');
    const [create, setCreate] = useState(false);
    const [activeOn, setActiveOn] = useState(false);


    const TABS = {
        Employee_Portal: 'Employee Portal',
        Flexible_Benefit_Plan: 'Flexible Benefit Plan',
        Reimbursement_Claims: ' Reimbursement Claims',
        Income_Tax_Declaration: ' Income Tax Declaration',
        Proof_Of_Investments: 'Proof Of Invesments',
        Employee: 'Employee',
        Sender_Email_Preference: 'Sender Email Preference',
    };

    const [activeTab, setActiveTab] = useState(text != undefined ? TABS.Sender_Email_Preference : TABS.Employee_Portal);
    function handleCheck() {
        setRadioButtonChecked(!radioButtonChecked)
    }

    //POI checkbox
    const [poichecked, setPoiChecked] = useState(false);
    function poiChecked() {
        setPoiChecked(!poichecked)
    }

    const [itchecked, setItChecked] = useState(false);
    function itChecked() {
        setItChecked(!itchecked)
    }

    const [poiItchecked, setPoiItChecked] = useState(false);
    function poiItChecked() {
        setPoiItChecked(!poiItchecked)
    }

    const [dooChecked, setDooChecked] = useState(false);
    function dooCheck() {
        setDooChecked(!dooChecked)
    }
    const [checked, setChecked] = useState(false);
    function Checked() {
        setChecked(!checked)
    }
    const [bychecked, setByChecked] = useState(false);
    function byCheck() {
        setByChecked(!bychecked)
    }

    //IT checkbox
    const [perferenceChecked, setPerferenceChecked] = useState(false);
    function perferenceCheck() {
        setPerferenceChecked(!perferenceChecked)
    }
    const [itCheckBox, setItCheckBox] = useState(false);
    function CheckBox() {
        setItCheckBox(!itCheckBox)
    }
    const [bycheck, setBycheck] = useState(false);
    function byInCheck() {
        setBycheck(!bycheck)
    }
    const [andchecked, setAndChecked] = useState(false);
    function addCheck() {
        setAndChecked(!andchecked)
    }

    const exampleInline = useFormik({
        initialValues: {
            exampleInlineOne: true,
            exampleInlineTwo: false,
            exampleInlineThree: false,
        },
        onSubmit: () => { },
    });

    return (
        <PageWrapper>
            <Page>
                <div className='row h-100'>
                    <div className='col-xl-3 col-lg-4 col-md-6'>
                        <Card stretch>
                            <CardHeader>
                                <CardTitle tag='div' className='h4'>
                                    PREFERENCE
                                </CardTitle>
                            </CardHeader>
                            <CardBody isScrollable>
                                <div className='row g-3'>
                                    <div className='col-12'>
                                        <Button
                                            color='info'
                                            className='w-100 p-3 text-start'
                                            isLight={TABS.Employee_Portal !== activeTab}
                                            onClick={() => setActiveTab(TABS.Employee_Portal)}>
                                            {TABS.Employee_Portal}
                                        </Button>
                                    </div>
                                    <div className='col-12'>
                                        <Button
                                            color='info'
                                            className='w-100 p-3 text-start'
                                            isLight={TABS.Flexible_Benefit_Plan !== activeTab}
                                            onClick={() => setActiveTab(TABS.Flexible_Benefit_Plan)}>
                                            {TABS.Flexible_Benefit_Plan}
                                        </Button>
                                    </div>
                                    <div className='col-12'>
                                        <Button
                                            color='info'
                                            className='w-100 p-3 text-start'
                                            isLight={TABS.Reimbursement_Claims !== activeTab}
                                            onClick={() => setActiveTab(TABS.Reimbursement_Claims)}>
                                            {TABS.Reimbursement_Claims}
                                        </Button>
                                    </div>
                                    <div className='col-12'>
                                        <Button
                                            color='info'
                                            className='w-100 p-3 text-start'
                                            isLight={TABS.Income_Tax_Declaration !== activeTab}
                                            onClick={() => setActiveTab(TABS.Income_Tax_Declaration)}>
                                            {TABS.Income_Tax_Declaration}
                                        </Button>
                                    </div>
                                    <div className='col-12'>
                                        <Button
                                            color='info'
                                            className='w-100 p-3 text-start'
                                            isLight={TABS.Proof_Of_Investments !== activeTab}
                                            onClick={() => setActiveTab(TABS.Proof_Of_Investments)}>
                                            {TABS.Proof_Of_Investments}
                                        </Button>
                                    </div>
                                    <div className='col-12'>
                                        <Button
                                            color='info'
                                            className='w-100 p-3 text-start'
                                            isLight={TABS.Employee !== activeTab}
                                            onClick={() => setActiveTab(TABS.Employee)}>
                                            {TABS.Employee}
                                        </Button>
                                    </div>
                                    <div className='row-g-5'>
                                        <div className='col-12'>
                                            <Button
                                                color='info'
                                                className='w-100 p-3 text-start'
                                                isLight={TABS.Sender_Email_Preference !== activeTab}
                                                onClick={() => setActiveTab(TABS.Sender_Email_Preference)}>
                                                {TABS.Sender_Email_Preference}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                    <div className='col-xl-9 col-lg-8 col-md-6'>

                        {/* Employee Portal */}

                        {TABS.Employee_Portal === activeTab && (
                            <Card stretch>
                                <CardHeader borderSize={1}>
                                    <CardLabel>
                                        <CardTitle tag='div' className='h4'>
                                            Employee Portal
                                        </CardTitle>
                                    </CardLabel>
                                </CardHeader>
                                <CardBody className='pb-0' isScrollable>
                                    <div className="row">
                                        <div className='col-11'>
                                            <div className="row g-3">
                                                <CardTitle tag='div' className='h5'> Enable Portal Access
                                                    <Badge
                                                        color='success'
                                                        isLight
                                                        className='px-3 py-2'
                                                    >
                                                        ACTIVE
                                                    </Badge>
                                                </CardTitle>
                                            </div>
                                        </div>
                                        <div className='col-1'>
                                            <Checks
                                                type='switch'
                                                id='inlineRadioOne'
                                                name='radios'
                                                value='first'
                                                checked={activeOn}
                                                onClick={() => setActiveOn(!activeOn)}
                                            />
                                        </div>
                                        <div className='col-11'>
                                            <p>The employee portal allows your employees to access their salary information and perform payroll related activities like declaring their Flexible Benefit Plan (FBP) and submitting investment proofs for approval.
                                            </p>
                                        </div>
                                        {activeOn ?
                                            <>
                                                <div className='col-11 mt-4'>
                                                    <h5>Portal Contact Information</h5></div>
                                                <div className='col-11'>
                                                    <p>This is the email address to which your employees can send queries through the portal.
                                                    </p>
                                                </div>
                                                <div className='col-11 mt-4'>
                                                    <Card borderSize={1}>
                                                        <div className='col-12 mt-2'></div>
                                                        <div className="row">
                                                            <div className='col-1'></div>
                                                            <div className='col-5 g-1'>
                                                                <div className='d-flex align-items-center'>
                                                                    <div className='flex-shrink-0'>
                                                                        <div>
                                                                            <Avatar
                                                                                srcSet={'https://365webresources.com/wp-content/uploads/2016/09/FREE-PROFILE-AVATARS.png'}
                                                                                src={'https://365webresources.com/wp-content/uploads/2016/09/FREE-PROFILE-AVATARS.png'}
                                                                                className='rounded-circle'
                                                                                size={70}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className='flex-grow-1 ms-3'>
                                                                        <div className='h5 fw-bold'>
                                                                            snehajoe16291
                                                                        </div>
                                                                        <div className='h6 text-muted'>snehajoe16291@gmail.com
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className='col-4'>
                                                                    </div>
                                                                    <div className="col-8 text-primary gap-3 align-self-center">
                                                                        <Button
                                                                            onClick={() => setManageContactsOpen(true)}
                                                                            isLink >
                                                                            <Icon icon='Settings' size='lg' color='primary' />
                                                                            <span className="text-primary"> Manage Contacts</span>
                                                                        </Button>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-12 mt-2'></div>
                                                    </Card>
                                                </div>
                                                <div className='col-11 mt-4'>
                                                    <h5>Banner Message</h5>
                                                </div>
                                                <div className='col-11'>
                                                    <p>Send important notifications or announcements to your employees using this space. The message you enter here will be displayed at the top of the Home page in the Employee Self-service Portal.
                                                        <div className='col-8 mt-2 text-primary gap-3 align-self-center'
                                                            onClick={() => setView(!view)}>
                                                            <Dropdown className='d-inline'>
                                                                <DropdownToggle hasIcon={false} >
                                                                    <Button color='light' size='sm' icon='RemoveRedEye'>
                                                                        View Sample Preview
                                                                    </Button>
                                                                </DropdownToggle>
                                                                <DropdownMenu isAlignmentEnd isCloseAfterLeave={false}>
                                                                    <DropdownItem>
                                                                        <svg version="1.1" x="0" y="0" viewBox="0 0 481 218.7" className="icon align-middle" style={{ height: '200px', width: '460px' }}>
                                                                            <path d="M10 0h81.4v218.7H0V10C0 4.5 4.5 0 10 0z" fill-rule="evenodd" clip-rule="evenodd" fill="#272b33"></path><path d="M480.5.5H90.8v217.7h389.6V.5z" fill-rule="evenodd" clip-rule="evenodd" fill="#fff" stroke="#edf0fa">
                                                                            </path>
                                                                            <path fill="#f6f7fa" d="M107 51h374v78H107z"></path>
                                                                            <path d="M162.4 75.4v-6.1h.1l2.5 6.1h.9l2.5-6.1h.1v6.1h.9v-8h-1.2l-2.7 6.6h-.1l-2.7-6.6h-1.2v8h.9zm11.2.1c.4 0 .7-.1 1.1-.2.3-.1.6-.3.8-.5.2-.2.4-.5.5-.8l-.9-.2c-.1.2-.2.4-.3.5-.1.1-.3.2-.5.3-.2.1-.4.1-.7.1-.3 0-.7-.1-1-.2-.3-.2-.5-.4-.6-.7-.2-.4-.3-.8-.2-1.2v.1h4.4v-.4c0-.5-.1-1-.2-1.4-.1-.3-.3-.7-.6-.9-.2-.2-.5-.4-.8-.5-.3-.1-.6-.1-.9-.2-.5 0-1 .1-1.4.4-.4.3-.7.7-.9 1.1-.2.5-.4 1.1-.3 1.6 0 .6.1 1.1.3 1.6.2.5.6.8 1 1.1.2.3.7.4 1.2.4zm-1.8-3.7c0-.3.1-.5.2-.7.1-.3.4-.5.6-.7.3-.2.6-.3 1-.3.3 0 .6.1.9.2.2.2.4.4.5.6.1.3.2.6.2.9h-3.4zm7.7 3.7c.4 0 .8-.1 1.2-.2.3-.1.6-.4.8-.7.2-.3.3-.6.3-.9 0-.4-.1-.7-.4-1-.3-.3-.8-.5-1.2-.6l-.9-.2c-.3-.1-.5-.2-.8-.3-.2-.1-.3-.3-.2-.6 0-.3.1-.5.4-.6.3-.2.6-.3.9-.3.2 0 .5 0 .7.1.2.1.3.2.4.3.1.1.2.3.2.4l.8-.2c-.1-.4-.4-.7-.7-1-.4-.3-.9-.4-1.4-.4-.4 0-.8.1-1.1.2-.3.1-.6.3-.8.6-.2.3-.3.6-.3.9 0 .4.1.7.4 1 .3.3.8.5 1.2.6l1 .2c.2 0 .5.1.7.3.1.1.2.3.2.5 0 .3-.2.5-.4.7-.3.2-.6.3-1 .3-.3 0-.6-.1-.9-.2-.2-.2-.4-.4-.5-.7l-.9.2c.1.5.4.9.8 1.2.5.3 1 .4 1.5.4zm5.8 0c.4 0 .8-.1 1.2-.2.3-.1.6-.4.8-.7.2-.3.3-.6.3-.9 0-.4-.1-.7-.4-1-.3-.3-.8-.5-1.2-.6l-.9-.2c-.3-.1-.5-.2-.8-.3-.2-.1-.3-.3-.2-.6 0-.3.1-.5.4-.6.3-.2.6-.3.9-.3.2 0 .5 0 .7.1.2.1.3.2.4.3.1.1.2.3.2.4l.8-.2c-.1-.4-.4-.7-.7-1-.4-.3-.9-.4-1.4-.4-.4 0-.8.1-1.1.2-.3.1-.6.3-.8.6-.2.3-.3.6-.3.9 0 .4.1.7.4 1 .3.3.8.5 1.2.6l1 .2c.2 0 .5.1.7.3.1.1.2.3.2.5 0 .3-.2.5-.4.7-.3.2-.6.3-1 .3-.3 0-.6-.1-.9-.2-.2-.2-.4-.4-.5-.7l-.9.3c.1.5.4.9.8 1.2.4.2 1 .3 1.5.3zm5.5 0c.3 0 .6 0 .9-.2.2-.1.4-.2.6-.4.1-.1.2-.3.3-.4v.8h.9v-4c0-.4-.1-.8-.2-1.1-.1-.3-.3-.5-.6-.6-.2-.1-.5-.2-.7-.3-.2 0-.4-.1-.7-.1-.3 0-.6 0-.9.1-.3.1-.6.2-.9.4-.3.2-.5.5-.6.8l.9.3c.1-.2.3-.5.5-.6.3-.2.6-.3 1-.3s.7.1 1 .3c.2.2.3.6.3.9 0 .1-.1.2-.2.3-.2.1-.3.1-.5.1l-.9.1c-.3 0-.6.1-.8.1-.3.1-.5.2-.8.3-.2.1-.4.3-.5.5-.1.3-.2.5-.2.8 0 .4.1.7.3 1 .2.3.4.5.7.6.3.5.7.6 1.1.6zm.1-.8c-.3 0-.6-.1-.9-.2-.2-.2-.4-.4-.4-.7 0-.2.1-.4.2-.6.1-.1.3-.3.5-.3.2-.1.4-.1.7-.2h.4l.5-.1c.2 0 .3-.1.4-.1.1 0 .2-.1.3-.1v.8c0 .3-.1.5-.2.7-.1.2-.3.4-.6.6-.2.1-.5.2-.9.2zm6.7 3c.4 0 .9-.1 1.3-.2s.7-.4.9-.7c.2-.4.4-.8.4-1.3v-6.1h-.9v1h-.1c-.1-.1-.2-.3-.3-.4-.1-.2-.3-.3-.5-.4-.3-.1-.6-.2-.9-.2-.5 0-.9.1-1.3.4-.4.3-.7.6-.9 1.1-.2.5-.3 1-.3 1.6 0 .6.1 1.1.3 1.6.2.4.5.8.9 1 .4.2.8.3 1.3.3.3 0 .6 0 .9-.2.2-.1.4-.3.5-.4.1-.1.2-.3.3-.4h.1v1.2c0 .4-.1.8-.5 1.1-.4.2-.8.4-1.2.3-.3 0-.6 0-.9-.2-.2-.1-.4-.2-.5-.4-.1-.1-.2-.3-.3-.4l-.7.5c.1.2.3.4.5.6.2.2.5.4.8.4.4.2.8.3 1.1.2zm0-3.3c-.4 0-.7-.1-1-.3-.3-.2-.5-.4-.6-.8-.1-.3-.2-.7-.2-1.1 0-.4.1-.8.2-1.1.1-.3.3-.6.6-.8.3-.2.6-.3 1-.3.3 0 .7.1.9.3.3.2.5.5.6.8.1.4.2.8.2 1.2 0 .4-.1.8-.2 1.1-.1.3-.3.6-.6.7-.2.3-.5.4-.9.3zm6.9 1c.4 0 .7-.1 1.1-.2.3-.1.6-.3.8-.5.2-.2.4-.5.5-.8l-.9-.2c-.1.4-.4.7-.8.8-.2.1-.4.1-.7.1-.3 0-.7-.1-1-.2-.3-.2-.5-.4-.7-.7-.2-.4-.3-.8-.2-1.2v.1h4.4v-.3c0-.5-.1-1-.2-1.4-.1-.3-.3-.7-.6-.9-.2-.2-.5-.4-.8-.5-.3-.1-.6-.1-.9-.2-.5 0-1 .1-1.4.4-.4.3-.7.7-.9 1.1-.2.5-.4 1.1-.3 1.6 0 .5.1 1.1.3 1.6.2.4.6.8 1 1.1.2.3.7.4 1.3.3zm-1.9-3.6c0-.3.1-.5.2-.7.1-.3.3-.5.6-.7.3-.2.6-.3.9-.3.3 0 .6.1.9.2.2.1.4.4.6.6.1.3.2.6.2.9h-3.4zm10.2 3.5v-5.1h1.3v-.8h-1.4v-.6c0-.2 0-.4.1-.6l.1-.1c.2-.2.4-.3.7-.2h.3l.2.1.3-.8c-.1 0-.2-.1-.3-.1h-.6c-.3 0-.6.1-.8.2-.3.1-.5.3-.6.5-.2.3-.3.6-.2.9v.8h-1v.8h1v5.2l.9-.2zm3.5 0v-3.8c0-.3.1-.5.2-.7.1-.2.3-.4.5-.5.2-.1.5-.2.8-.2H218.4v-.8h-.5c-.4 0-.7.1-1 .3-.3.2-.5.4-.6.7h-.1v-.9h-.9v6l1-.1zm5.7.1c1 0 1.9-.5 2.3-1.4.2-.5.4-1.1.3-1.6 0-.6-.1-1.1-.3-1.6-.2-.4-.5-.8-.9-1.1-.4-.2-.9-.4-1.4-.3-.5 0-1 .1-1.4.4-.4.3-.8.6-1 1.1-.2.5-.3 1.1-.3 1.6 0 .6.1 1.1.3 1.6.4.9 1.3 1.4 2.4 1.3zm0-.8c-.4 0-.7-.1-1-.3-.3-.2-.5-.5-.6-.8-.1-.4-.2-.7-.2-1.1 0-.4.1-.8.2-1.1.1-.3.3-.6.6-.8.3-.2.6-.3 1-.3s.7.1 1 .3c.3.2.5.5.6.8.1.4.2.7.2 1.1 0 .4-.1.8-.2 1.1-.1.3-.3.6-.6.8-.3.2-.7.4-1 .3zm5 .7v-3.7c0-.3.1-.5.2-.8.1-.2.3-.4.5-.5.2-.1.4-.2.7-.2.3 0 .6.1.9.3.2.2.4.5.3.8v4.1h.9v-3.9c0-.4.1-.7.4-1 .3-.3.6-.4 1-.4.3 0 .6.1.9.3.3.3.4.6.4 1v4h.9v-4c0-.6-.1-1.1-.5-1.6-.4-.3-.8-.5-1.3-.5-.4 0-.8.1-1.1.3-.3.2-.5.4-.7.7h-.1c-.1-.3-.3-.6-.6-.8-.3-.2-.6-.3-1-.3s-.7.1-1 .3c-.3.2-.5.4-.6.8h-.1v-.9h-.9v6h.8zm16.8 0v-.9h-3.9v-2.6h3.6v-.9h-3.6v-2.7h3.9v-.8H239v8l4.8-.1zm2.4 0v-3.7c0-.3.1-.5.2-.8.1-.2.3-.4.5-.5.2-.1.4-.2.7-.2.3 0 .6.1.9.3.2.2.3.5.3.8v4.1h.9v-3.9c0-.4.1-.7.3-1 .3-.3.6-.4 1-.4.3 0 .6.1.9.3.3.3.4.6.4 1v4h.9v-4c.1-.6-.1-1.1-.5-1.6-.3-.3-.8-.5-1.3-.5-.4 0-.8.1-1.1.3-.3.2-.5.4-.7.7h-.1c-.1-.3-.4-.6-.6-.8-.3-.2-.6-.3-1-.3s-.7.1-1 .3c-.3.2-.5.4-.6.8h-.1v-.9h-.9v6h.9zm9.6 2.2v-3.1h.1l.3.4c.4.4.9.7 1.5.6.5 0 .9-.1 1.3-.4.4-.3.7-.6.9-1.1.4-1.1.4-2.2 0-3.3-.2-.4-.5-.8-.9-1.1-.4-.3-.9-.4-1.3-.4-.3 0-.6 0-.9.2-.2.1-.4.3-.5.4-.1.2-.2.3-.3.4h-.1v-1h-.9v8.2l.8.2zm1.7-3c-.3 0-.7-.1-.9-.3-.3-.2-.5-.5-.6-.8-.1-.4-.2-.8-.2-1.2 0-.4.1-.8.2-1.2.1-.3.3-.6.6-.8.3-.2.6-.3 1-.3s.7.1 1 .3c.3.2.5.5.6.8.1.4.2.8.2 1.2 0 .4-.1.8-.2 1.2-.1.3-.3.6-.6.8-.3.3-.6.4-1 .4l-.1-.1zm5 .8v-8h-.9v8h.9zm4.1.1c.5 0 1-.1 1.4-.4.4-.2.7-.6.9-1 .2-.5.4-1.1.3-1.6 0-.6-.1-1.1-.3-1.6-.7-1.3-2.3-1.9-3.7-1.2 0 0-.1 0-.1.1-.4.3-.8.6-1 1.1-.2.5-.4 1.1-.4 1.6 0 .6.1 1.1.4 1.6.2.5.6.8 1 1.1.4.3.9.4 1.4.4l.1-.1zm0-.9c-.4 0-.7-.1-1-.3-.3-.2-.5-.5-.6-.8-.1-.4-.2-.7-.2-1.1 0-.4.1-.8.2-1.1.1-.3.3-.6.6-.8.3-.2.6-.3 1-.3s.7.1 1 .3c.3.2.5.5.6.8.1.4.2.7.2 1.1 0 .4-.1.8-.2 1.1-.1.3-.3.6-.6.8-.3.3-.6.4-1 .4v-.1zm4.7 3c.3 0 .5 0 .8-.2.2-.1.4-.3.6-.4.2-.2.3-.5.4-.8l2.5-6.9h-1l-1.7 4.9-1.7-4.8h-1l2.2 6-.2.5c-.2.4-.4.7-.6.8-.3.1-.6.1-.8 0l-.2.8c.1 0 .2.1.2.1.1 0 .3.1.4.1l.1-.1zm8.1-2.1c.4 0 .7-.1 1.1-.2.3-.1.6-.3.8-.5.2-.2.4-.5.5-.8l-.9-.2c-.1.2-.2.4-.3.5-.1.1-.3.2-.5.3-.2.1-.4.1-.7.1-.3 0-.7-.1-1-.2-.3-.2-.5-.4-.7-.7-.2-.4-.3-.8-.2-1.2v.1h4.4v-.3c0-.5-.1-1-.2-1.4-.1-.3-.3-.7-.6-.9-.2-.2-.5-.4-.8-.5-.3-.1-.6-.1-.9-.2-.5 0-1 .1-1.4.4-.4.3-.7.7-.9 1.1-.2.5-.4 1.1-.3 1.6 0 .5.1 1.1.4 1.6.2.5.6.8 1 1.1.4.3.9.4 1.4.4l-.2-.1zm-1.9-3.7c0-.3.1-.5.2-.7.1-.3.3-.5.6-.7.3-.2.6-.3 1-.3.3 0 .6.1.9.2.2.1.4.4.6.6.1.3.2.6.2.9h-3.5zm6.7 3.6v-3.8c0-.3.1-.5.2-.7.1-.2.3-.4.5-.5.2-.1.5-.2.8-.2h.5v-.7h-.5c-.4 0-.7.1-1 .3-.3.2-.5.4-.6.7h-.1v-.9h-.9v6l1.1-.2z" fill="#6b6b6b"></path>
                                                                            <path d="M162.6 94.4V91h4v3.5h1.2v-8h-1.2V90h-4v-3.5h-1.2v8h1.2zm7.4-6.9c.4 0 .7-.4.7-.7 0-.4-.4-.7-.7-.7-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm.6 6.9v-6h-1.2v6h1.2zm6.6.1c.3 0 .5 0 .8-.1l-.2-1h-.4c-.4 0-.7-.1-.7-.8v-3.3h1.2v-.9h-1.2V87h-1.2v1.4h-.9v.9h.9v3.6c0 .9.6 1.6 1.5 1.6h.2zm3.1-.1v-3.6c-.1-.8.5-1.4 1.3-1.5h.2c.7 0 1.3.5 1.3 1.2V94.4h1.2v-3.8c.1-1.1-.6-2.1-1.7-2.2h-.3c-.7-.1-1.5.3-1.8 1h-.1v-3h-1.1v8h1zm8 .2c1.1.1 2.1-.6 2.5-1.6l-1.1-.2c-.2.6-.8.9-1.4.8-.9 0-1.7-.7-1.7-1.6v-.2h4.3v-.4c0-2.2-1.3-3-2.7-3-1.7.2-2.9 1.8-2.7 3.5.3 1.4 1.4 2.5 2.8 2.7zm1.5-3.7h-3.1c0-.9.7-1.6 1.6-1.6.8 0 1.5.6 1.5 1.4v.2zm3.6 3.5v-3.7c0-.7.6-1.4 1.3-1.4h.1c.2 0 .4 0 .6.1v-1.1h-.5c-.7 0-1.3.4-1.5 1h-.1v-1h-1.1v6l1.2.1zm5.6.2c1.1.1 2.1-.6 2.5-1.6l-1.1-.2c-.2.6-.8.9-1.4.8-.9 0-1.7-.7-1.7-1.6v-.2h4.3v-.4c0-2.2-1.3-3-2.6-3-1.7.2-3 1.7-2.8 3.4.1 1.5 1.3 2.7 2.8 2.8zm1.5-3.7h-3.1c0-.9.7-1.6 1.6-1.6.8 0 1.5.6 1.5 1.4v.2zm3.8 1.2l.1-5.7h-1.3l.1 5.7h1.1zm-.6 2.4c.4 0 .8-.3.8-.8s-.3-.8-.8-.8-.8.3-.8.8.4.8.8.8c0 0 .1 0 0 0zm8.9-.1v-3.1l2.9-4.8h-1.4l-2.1 3.6-2-3.6h-1.4l2.9 4.8v3.2h1.1zm6.5.2c1.7.2 3.2-1.1 3.4-2.8s-1.1-3.2-2.8-3.4c-1.7-.2-3.2 1.1-3.4 2.8v.3c-.2 1.5.9 2.9 2.5 3.1h.3zm0-1c-1.1 0-1.6-1-1.6-2.1s.5-2.1 1.6-2.1 1.6 1 1.6 2.1-.5 2.1-1.6 2.1zm6.1.9c.8 0 1.5-.4 1.8-1.1h.1v1h1.1v-6h-1.1V92c0 .8-.6 1.5-1.3 1.5h-.1c-.7 0-1.2-.5-1.2-1.2V88.4h-1.2v3.8c-.1 1.6.8 2.3 1.9 2.3zm5.7-.1v-3.7c0-.8.6-1.4 1.4-1.4h.1c.2 0 .4 0 .6.1v-1.1h-.5c-.7 0-1.3.4-1.5 1v-1h-1.1v6l1 .1zm8.1.2c1.4 0 2.4-.8 2.4-1.9 0-.8-.5-1.4-1.6-1.6l-.9-.2c-.7-.2-.9-.4-.9-.8s.5-.8 1.2-.8c.5 0 1 .3 1.2.8l1.1-.2c-.3-1-1.2-1.7-2.3-1.5-1.4 0-2.3.7-2.3 1.8 0 .9.5 1.4 1.6 1.7l1 .2c.6.1.9.4.9.8s-.5.8-1.3.8c-.6.1-1.2-.3-1.3-.9l-1.1.2c.2 1 1 1.6 2.3 1.6zm5.5 0c.7 0 1.4-.3 1.8-1h.1v.8h1.1v-4c.1-1.1-.8-2-1.9-2.1h-.5c-1.1-.1-2.1.5-2.5 1.5l1.1.2c.2-.5.8-.9 1.4-.8.5-.1 1.1.3 1.1.8v.2c0 .4-.4.4-1.5.6s-2.3.4-2.3 1.8c-.1 1 .7 1.9 1.7 2h.4zm.3-1c-.7 0-1.1-.3-1.1-.9s.6-.8 1.2-.9c.5 0 1-.1 1.4-.3v.8c0 .8-.6 1.4-1.4 1.4 0-.1-.1-.1-.1-.1zm5.4.8v-8H249v8h1.2zm3.3.1c.7 0 1.4-.3 1.8-1h.1v.8h1.1v-4c.1-1.1-.8-2-1.9-2.1h-.5c-1.1-.1-2.1.5-2.5 1.5l1.1.2c.2-.5.8-.9 1.4-.8.5-.1 1.1.3 1.1.8v.2c0 .4-.4.4-1.5.6s-2.3.4-2.3 1.8c-.1 1 .7 1.9 1.7 2 .2.1.3.1.4 0zm.3-.9c-.7 0-1.1-.3-1.1-.9s.6-.8 1.2-.9c.5 0 1-.1 1.4-.3v.8c0 .8-.6 1.4-1.4 1.4 0-.1-.1-.1-.1-.1zm5.4.8v-3.6c0-.7.6-1.4 1.3-1.4h.1c.2 0 .4 0 .6.1v-1.1h-.5c-.7 0-1.3.4-1.5 1h-.1v-1H258v6h1.2zm3.8 2.2c.9 0 1.7-.5 1.9-1.4l2.5-6.8h-1.3l-1.5 4.7h-.1l-1.5-4.7h-1.2l2.2 6.1-.1.4c-.1.5-.7.9-1.2.7h-.1l-.3 1c.2.1.5.1.7 0zm9.6-2.2v-3.5c-.1-.8.5-1.4 1.3-1.5h.2c.7 0 1.3.5 1.3 1.2V94.5h1.2v-3.8c.1-1.1-.6-2.1-1.7-2.2h-.3c-.7-.1-1.5.3-1.8 1h-.1v-3h-1.1v8l1-.1zm7.2.1c.7 0 1.4-.3 1.8-1v.8h1.1v-4c.1-1.1-.8-2-1.9-2.1h-.5c-1.1-.1-2.1.6-2.5 1.6l1.1.2c.2-.6.8-.9 1.4-.8.5-.1 1.1.3 1.1.8v.2c0 .4-.4.4-1.5.6s-2.3.4-2.3 1.8c0 1 .8 1.8 1.8 1.9.3.1.3.1.4 0zm.2-.9c-.7 0-1.1-.3-1.1-.9s.5-.8 1.2-.9c.5 0 1-.1 1.4-.3v.8c0 .8-.6 1.4-1.4 1.4 0-.1 0-.1-.1-.1zm6.5.9c1.5 0 2.5-.8 2.5-1.9 0-.8-.5-1.4-1.6-1.6l-1-.2c-.7-.2-.9-.4-.9-.8s.5-.8 1.2-.8c.5 0 1 .3 1.2.8l1.1-.2c-.3-1-1.2-1.7-2.3-1.5-1.4 0-2.3.7-2.3 1.8 0 .9.5 1.4 1.6 1.7l1 .2c.6.1.9.4.9.8s-.5.8-1.3.8c-.6.1-1.2-.3-1.3-.9l-1.1.2c.1 1.1 1 1.7 2.3 1.6zm9.7 0c1.5 0 2.5-1.2 2.5-3.1s-1.1-3.1-2.5-3.1c-.7 0-1.4.3-1.7 1h-.1v-3h-1.1v8h1.1v-.9h.1c.3.7 1 1.2 1.7 1.1zm-.3-1c-1 0-1.6-.9-1.6-2.1s.5-2.1 1.6-2.1 1.6.9 1.6 2.1-.5 2.2-1.6 2.1zm6.7 1c1.1.1 2.1-.6 2.5-1.6l-1.1-.2c-.2.6-.8.9-1.4.8-.9 0-1.7-.7-1.7-1.6v-.2h4.3v-.4c0-2.2-1.3-3-2.7-3-1.7.2-2.9 1.8-2.7 3.5.2 1.5 1.3 2.6 2.8 2.7zm1.4-3.6h-3c0-.9.7-1.6 1.6-1.6.8 0 1.5.7 1.5 1.5 0 0 0 .1-.1.1zm5 3.6c1.1.1 2.1-.6 2.5-1.6l-1.1-.2c-.2.6-.8.9-1.4.8-.9 0-1.7-.7-1.7-1.6v-.2h4.3v-.4c0-2.2-1.3-3-2.7-3-1.7.2-2.9 1.8-2.7 3.5.2 1.5 1.4 2.6 2.8 2.7zm1.4-3.6h-3.1c0-.9.7-1.6 1.6-1.6.8-.1 1.5.6 1.6 1.4 0 .1 0 .1-.1.2zm3.6 3.5v-3.5c-.1-.7.5-1.4 1.2-1.5h.2c.7 0 1.3.5 1.3 1.2V94.5h1.2v-3.8c0-1.5-.8-2.3-2-2.3-.7-.1-1.4.3-1.8 1h-.1v-1h-1v6h1zm9.5 0v-3.6c0-.7.6-1.4 1.3-1.4h.1c.2 0 .4 0 .6.1v-1.1h-.5c-.7 0-1.3.4-1.5 1h-.1v-1h-1.1v6h1.2zm5.7.1c1.1.2 2.2-.5 2.6-1.5l-1.1-.2c-.2.6-.8.9-1.4.8-.9 0-1.7-.7-1.7-1.6v-.2h4.3v-.4c0-2.2-1.3-3-2.7-3-1.7.2-2.9 1.8-2.7 3.5.1 1.5 1.3 2.6 2.7 2.6zm1.4-3.6h-3.1c0-.9.7-1.6 1.6-1.6.8-.1 1.5.5 1.6 1.4 0 0 0 .1-.1.2zm5.4 3.5l2.2-6H337l-1.5 4.6h-.1l-1.4-4.6h-1.2l2.2 6h1zm4-6.9c.4 0 .7-.2.8-.6 0-.4-.2-.7-.6-.8h-.2c-.4 0-.7.2-.8.6 0 .4.2.7.6.8h.2zm.5 6.9v-6h-1.2v6h1.2zm3.8.2c1.5 0 2.5-.8 2.5-1.9 0-.8-.5-1.4-1.6-1.6l-1-.2c-.7-.2-1-.4-.9-.8s.5-.8 1.2-.8c.5 0 1 .3 1.2.8l1.1-.2c-.3-1-1.2-1.7-2.3-1.5-1.4 0-2.3.7-2.3 1.8 0 .9.5 1.4 1.6 1.7l1 .2c.6.1.9.4.9.8s-.5.8-1.3.8c-.6.1-1.2-.3-1.3-.9l-1.1.2c0 1 1 1.6 2.3 1.6zm6.3 0c1.1.1 2.1-.6 2.5-1.6l-1.1-.2c-.2.6-.8.9-1.4.8-.9 0-1.7-.7-1.7-1.6v-.2h4.3v-.4c0-2.2-1.3-3-2.6-3-1.7.2-3 1.7-2.8 3.4 0 1.5 1.3 2.7 2.8 2.8zm1.4-3.7h-3.1c0-.9.7-1.6 1.6-1.6.8 0 1.5.6 1.5 1.5v.1zm4.7 3.7c.7 0 1.4-.4 1.7-1h.1v.9h1.1v-8h-1.2v3h-.1c-.3-.6-1-1-1.7-1-1.5 0-2.5 1.1-2.5 3.1s1.1 3 2.6 3zm.3-1c-1 0-1.6-.9-1.6-2.1s.5-2.1 1.6-2.1 1.6.8 1.6 2.1-.6 2.1-1.6 2.1zm5.1 1c.4 0 .8-.4.8-.8s-.4-.8-.8-.8-.8.4-.8.8.4.7.8.8zm9-.1l2.9-8h-1.3l-2.2 6.5h-.1l-2.2-6.5h-1.3l2.9 8h1.3zm4.5-6.9c.4 0 .7-.4.7-.7 0-.4-.4-.7-.7-.7-.4 0-.7.3-.7.7 0 .3.4.6.7.7zm.6 6.9v-6H375v6h1.2zm4.2.1c1.1.1 2.1-.6 2.5-1.6l-1.1-.2c-.2.6-.8.9-1.4.8-.9 0-1.7-.7-1.7-1.6v-.2h4.3v-.4c0-2.2-1.3-3-2.7-3-1.7.2-3 1.7-2.8 3.4.1 1.5 1.4 2.7 2.9 2.8zm1.4-3.6h-3.1c0-.9.7-1.6 1.6-1.6.8 0 1.5.6 1.5 1.5v.1zm4.9 3.5l1.2-4.4h.1l1.2 4.3h1.2l1.8-6H391l-1.2 4.4h-.1l-1.2-4.4h-1.2l-1.2 4.4h-.1l-1.2-4.4h-1.2l1.8 6 1.3.1zm10.7 0v-3.6c-.1-.7.5-1.4 1.2-1.5h.2c.7 0 1.3.5 1.3 1.2V94.5h1.2v-3.8c.1-1.1-.6-2.1-1.7-2.2h-.3c-.7-.1-1.4.3-1.8 1h-.1v-1h-1.1v6h1.1zm8 .1c1.1.1 2.2-.5 2.5-1.6l-1.1-.2c-.2.6-.8.9-1.4.8-.9 0-1.7-.7-1.7-1.6v-.2h4.2v-.4c0-2.2-1.3-3-2.7-3-1.7.2-3 1.7-2.8 3.4.2 1.5 1.5 2.7 3 2.8zm1.4-3.6h-3.1c0-.9.7-1.6 1.6-1.6.8 0 1.5.6 1.5 1.5v.1zm5 3.5l1.2-4.4h.1l1.2 4.3h1.2l1.8-6H416l-1.2 4.4-1.2-4.4h-1.2l-1.2 4.4h-.1l-1.2-4.4h-1.2l1.8 6 1.3.1zm11.6.1c1.5 0 2.5-.8 2.5-1.9 0-.8-.5-1.4-1.6-1.6l-1-.2c-.7-.2-1-.4-.9-.8s.5-.8 1.2-.8c.5 0 1 .3 1.2.8l1.1-.2c-.3-1-1.2-1.7-2.3-1.5-1.4 0-2.3.7-2.3 1.8 0 .9.5 1.4 1.6 1.7l1 .2c.6.1.8.4.8.8s-.5.8-1.3.8c-.6.1-1.2-.3-1.3-.9l-1.1.2c.2 1 1.1 1.6 2.4 1.6zm5.5 0c.7 0 1.4-.3 1.8-1v.8h1.1v-4c.1-1.1-.8-2-1.9-2.1h-.5c-1.1-.1-2.1.5-2.5 1.5l1.1.2c.2-.5.8-.9 1.4-.8.5-.1 1.1.3 1.1.8v.2c0 .4-.4.4-1.5.6s-2.3.4-2.3 1.8c0 1 .7 1.9 1.8 1.9.2.1.3.1.4.1zm.3-.9c-.7 0-1.1-.3-1.1-.9s.5-.8 1.2-.9c.5 0 1-.1 1.4-.3v.8c0 .7-.7 1.3-1.5 1.3 0-.1 0-.1 0 0zm5.4.8v-8h-1.2v8h1.2zm3.3.1c.7 0 1.4-.3 1.8-1v.8h1.1v-4c.1-1.1-.8-2-1.9-2.1h-.5c-1.1-.1-2.1.5-2.5 1.5l1.1.2c.2-.5.8-.9 1.4-.8.5-.1 1.1.3 1.1.8v.2c0 .4-.4.4-1.5.6s-2.3.4-2.3 1.8c0 1 .7 1.9 1.8 1.9.2.1.3.1.4.1zm.3-.9c-.7 0-1.1-.3-1.1-.9s.5-.8 1.2-.9c.5 0 1-.1 1.4-.3v.8c0 .7-.7 1.3-1.5 1.3 0-.1 0-.1 0 0zm5.4.8v-3.7c0-.8.6-1.4 1.4-1.4h.1c.2 0 .4 0 .6.1v-1.1h-.5c-.7 0-1.3.4-1.5 1h-.1v-1h-1.1v6l1.1.1zm3.8 2.2c.9 0 1.7-.6 1.9-1.4l2.5-6.8h-1.3l-1.5 4.7-1.5-4.7h-1.2l2.2 6.1-.1.4c-.3.8-.7.8-1.4.7l-.3 1h.7zm-284 14.9c1.4 0 2.4-.8 2.4-1.9 0-.8-.5-1.4-1.6-1.6l-.9-.2c-.7-.2-1-.4-.9-.8s.5-.8 1.2-.8c.5 0 1 .3 1.2.8l1.1-.2c-.3-1-1.2-1.7-2.3-1.5-1.4 0-2.3.7-2.3 1.8 0 .9.5 1.4 1.6 1.7l1 .2c.6.1.8.4.8.8s-.5.8-1.3.8c-.6.1-1.2-.3-1.3-.9l-1.1.2c.2 1 1.1 1.6 2.4 1.6zm5.9 0c.3 0 .5 0 .8-.1l-.2-1h-.4c-.4 0-.7-.1-.7-.8v-3.3h1.3v-.9h-1.2V104h-1.2v1.4h-.9v.9h.9v3.6c0 .9.6 1.6 1.5 1.6-.1 0 0 0 .1.1zm3.1-.1v-3.7c0-.8.6-1.4 1.4-1.4h.1c.2 0 .4 0 .6.1v-1.1h-.5c-.7 0-1.3.4-1.5 1h-.1v-1h-1.1v6l1.1.1zm5 .1c.8 0 1.5-.4 1.8-1.1h.1v1h1.1v-6h-1.2v3.5c0 .8-.5 1.4-1.3 1.5h-.1c-.7 0-1.2-.5-1.2-1.2V105.5h-1.2v3.8c.1 1.5.9 2.2 2 2.3zm7.1 0c1.2.1 2.3-.8 2.5-2h-1.1c-.1.6-.7 1-1.3 1-1 0-1.6-.8-1.6-2.1s.6-2.1 1.6-2.1c.6 0 1.2.4 1.3 1h1.1c-.2-1.2-1.2-2.1-2.5-2-1.7.2-2.9 1.7-2.7 3.5.1 1.4 1.2 2.5 2.7 2.7zm5.8 0c.3 0 .5 0 .8-.1l-.2-1h-.4c-.4 0-.7-.1-.7-.8v-3.3h1.2v-.9h-1.2V104h-1.2v1.4h-.9v.9h.9v3.6c0 .9.6 1.6 1.5 1.6.1 0 .2 0 .2.1zm3.9 0c.8 0 1.5-.4 1.8-1.1h.1v1h1.1v-6H196v3.5c0 .8-.6 1.5-1.3 1.5h-.1c-.7 0-1.2-.5-1.2-1.2V105.4h-1.2v3.8c.2 1.6 1 2.3 2 2.4zm5.8-.1v-3.7c0-.8.6-1.4 1.4-1.4h.1c.2 0 .4 0 .6.1v-1.1h-.5c-.7 0-1.3.4-1.5 1h-.1v-1h-1.1v6l1.1.1zm5.6.1c1.1.1 2.1-.6 2.5-1.6l-1.1-.2c-.2.6-.8.9-1.4.8-.9 0-1.7-.7-1.7-1.6v-.2h4.3v-.4c0-2.2-1.3-3-2.7-3-1.7.2-3 1.7-2.8 3.4.2 1.6 1.4 2.8 2.9 2.8zm1.5-3.6H204c0-.9.7-1.6 1.6-1.6.8 0 1.5.6 1.6 1.4-.1 0-.1.1-.1.2zm7.3 3.6c.8 0 1.5-.4 1.8-1.1h.1v1h1.1v-6h-1.2v3.5c0 .8-.6 1.5-1.3 1.5h-.1c-.7 0-1.2-.5-1.2-1.2V105.4h-1.2v3.8c.1 1.6.9 2.3 2 2.4zm5.7-.1V108c-.1-.7.5-1.4 1.2-1.5h.2c.7 0 1.3.5 1.3 1.2V111.6h1.2v-3.8c0-1.5-.8-2.3-2-2.3-.7-.1-1.4.3-1.8 1h-.1v-1H219v6h1.1zm7.7.1c.7 0 1.4-.4 1.7-1h.1v.9h1.1v-8h-1.2v3h-.1c-.3-.6-1-1-1.7-1-1.4 0-2.5 1.1-2.5 3.1s1.2 3 2.6 3zm.2-1c-1 0-1.6-.9-1.6-2.1s.5-2.1 1.6-2.1 1.6.8 1.6 2.1-.5 2.1-1.6 2.1zm7 1c1.1.1 2.1-.6 2.5-1.6l-1.1-.2c-.2.6-.8.9-1.4.8-.9 0-1.7-.7-1.7-1.6v-.2h4.3v-.4c0-2.2-1.3-3-2.7-3-1.7.2-2.9 1.8-2.7 3.5.2 1.5 1.4 2.6 2.8 2.7zm1.5-3.6h-3.1c0-.9.7-1.6 1.6-1.6.8 0 1.5.6 1.5 1.4v.2zm3.6 3.5v-3.7c0-.7.6-1.4 1.3-1.4h.1c.2 0 .4 0 .6.1v-1.1h-.5c-.7 0-1.3.4-1.5 1h-.1v-1h-1.1v6l1.2.1zm8.7.1c1.9 0 3-1 3-2.3s-1.3-2-2.3-2.2l-.8-.2c-.6-.2-1.5-.4-1.5-1.2s.6-1.2 1.6-1.2 1.6.4 1.7 1.2h1.2c0-1.3-1.2-2.2-2.8-2.2s-2.8.9-2.8 2.3c0 1.1.8 1.8 2.1 2.1l.9.2c.9.2 1.5.5 1.5 1.2s-.7 1.3-1.8 1.3-1.7-.4-1.8-1.3h-1.2c.1 1.4 1.3 2.3 3 2.3zm6.1 0c.7 0 1.4-.3 1.8-1v.8h1.1v-4c.1-1.1-.8-2-1.9-2.1h-.4c-1.1-.1-2.1.5-2.5 1.5l1.1.2c.2-.5.8-.9 1.4-.8.5-.1 1.1.3 1.1.8v.2c0 .4-.4.4-1.5.6-1.1.1-2.3.4-2.3 1.8 0 1 .8 1.8 1.8 1.9.1.1.2.1.3.1zm.2-.9c-.7 0-1.1-.3-1.1-.9s.6-.8 1.2-.9c.5 0 1-.1 1.5-.3v.8c-.1.7-.8 1.3-1.6 1.3zm5.5.8v-8h-1.2v8h1.2zm3.3.1c.7 0 1.4-.3 1.8-1v.8h1.1v-4c.1-1.1-.8-2-1.9-2.1h-.4c-1.1-.1-2.1.5-2.5 1.5l1.1.2c.2-.5.8-.9 1.4-.8.5-.1 1.1.3 1.1.8v.2c0 .4-.4.4-1.5.6s-2.3.4-2.3 1.8c0 1 .8 1.8 1.8 1.9.1.1.2.1.3.1zm.2-.9c-.7 0-1.1-.3-1.1-.9s.6-.8 1.2-.9c.5 0 1-.1 1.5-.3v.8c-.1.7-.8 1.3-1.6 1.3zm5.5.8v-3.7c0-.7.6-1.4 1.3-1.4h.1c.2 0 .4 0 .6.1v-1.1h-.5c-.7 0-1.3.4-1.5 1h-.1v-1h-1.1v6l1.2.1zm3.8 2.2c.9 0 1.7-.6 1.9-1.4l2.5-6.8h-1.3l-1.5 4.7-1.5-4.7h-1.2l2.2 6.1-.1.4c-.3.8-.7.8-1.4.7l-.3 1h.7zm11.1-2.2c2.4 0 3.9-1.5 3.9-4s-1.4-4-3.8-4H282v8h2.5zm-.1-1h-1.3v-6h1.4c1.8 0 2.6 1 2.6 2.9s-.9 3-2.7 3.1zm7.9 1.1c1.1.1 2.1-.6 2.5-1.6l-1.1-.2c-.2.6-.8.9-1.4.8-.9 0-1.7-.7-1.7-1.6v-.2h4.3v-.4c0-2.2-1.3-3-2.7-3-1.7.2-2.9 1.8-2.7 3.5.3 1.5 1.4 2.6 2.8 2.7zm1.4-3.6h-3.1c0-.9.7-1.6 1.6-1.6.8 0 1.5.6 1.5 1.4.1.1.1.1 0 .2zm4.6 3.6c.3 0 .5 0 .8-.1l-.2-1h-.4c-.4 0-.7-.1-.7-.8v-3.3h1.2v-.9h-1.2V104h-1.2v1.4h-.9v.9h.9v3.6c0 .9.6 1.6 1.5 1.6.1 0 .2 0 .2.1zm3.7 0c.7 0 1.4-.4 1.8-1v.8h1.1v-4c.1-1.1-.8-2-1.9-2.1h-.4c-1.1-.1-2.1.5-2.5 1.5l1.1.2c.2-.5.8-.9 1.4-.8.5-.1 1.1.3 1.1.8v.2c0 .4-.4.4-1.5.6s-2.3.4-2.3 1.8c0 1 .8 1.8 1.8 1.9.1.1.2.1.3.1zm.3-.9c-.7 0-1.1-.3-1.1-.9s.5-.8 1.2-.9c.5 0 1-.1 1.5-.3v.8c-.2.7-.8 1.3-1.6 1.3zm4.8-6.1c.4 0 .7-.2.8-.6 0-.4-.2-.7-.6-.8h-.2c-.4 0-.7.2-.8.6 0 .4.2.7.6.8h.2zm.6 6.9v-6h-1.2v6h1.2zm2.7 0v-8h-1.2v8h1.2zm3.8.1c1.4 0 2.5-.8 2.5-1.9 0-.8-.5-1.4-1.6-1.6l-1-.2c-.7-.2-.9-.4-.9-.8s.5-.8 1.2-.8c.5 0 1 .3 1.2.8l1.1-.2c-.3-1-1.2-1.7-2.3-1.5-1.4 0-2.3.7-2.3 1.8 0 .9.5 1.4 1.6 1.7l1 .2c.6.1.9.4.9.8s-.5.8-1.3.8c-.6.1-1.2-.3-1.3-.9l-1.1.2c.1 1 1 1.6 2.3 1.6zm4.5 0c.4 0 .8-.3.8-.8s-.3-.8-.8-.8-.8.3-.8.8c.1.4.4.7.8.7v.1z" fill="#333"></path><circle cx="120.8" cy="20.7" r="13.1" fill="#f6f7fa"></circle><g fill="#f6f7fa"><path d="M142.4 15.2h63.3c.6 0 1 .4 1 1v.2c0 .6-.4 1-1 1h-63.3c-.6 0-1-.4-1-1v-.2c0-.5.5-1 1-1zM142.4 25h89.4c.6 0 1 .4 1 1v1.3c0 .6-.4 1-1 1h-89.4c-.6 0-1-.4-1-1V26c0-.5.5-1 1-1z"></path></g><circle cx="45.7" cy="37" r="17.4" opacity=".11" fill="#fff"></circle><path d="M29.8 64.2h31.8c.8 0 1.5.7 1.5 1.5v.3c0 .8-.7 1.5-1.5 1.5H29.8c-.8 0-1.5-.7-1.5-1.5v-.3c0-.8.7-1.5 1.5-1.5z" opacity=".11" fill="#fff"></path><g opacity=".11" fill="#fff"><path d="M38.5 148h31.8c.8 0 1.5.7 1.5 1.5v.3c0 .8-.7 1.5-1.5 1.5H38.5c-.8 0-1.5-.7-1.5-1.5v-.3c0-.8.7-1.5 1.5-1.5z"></path><circle cx="21.8" cy="149.1" r="4.4"></circle></g><g opacity=".11" fill="#fff"><path d="M38.5 170.8h31.8c.8 0 1.5.7 1.5 1.5v.3c0 .8-.7 1.5-1.5 1.5H38.5c-.8 0-1.5-.7-1.5-1.5v-.3c0-.8.7-1.5 1.5-1.5z"></path><circle cx="21.8" cy="171.9" r="4.4"></circle></g><g opacity=".11" fill="#fff"><path d="M38.5 193.7h31.8c.8 0 1.5.7 1.5 1.5v.3c0 .8-.7 1.5-1.5 1.5H38.5c-.8 0-1.5-.7-1.5-1.5v-.3c0-.8.7-1.5 1.5-1.5z"></path><circle cx="21.8" cy="194.8" r="4.4"></circle></g><path d="M18.9 71.8h53.6c.8 0 1.5.7 1.5 1.5v.3c0 .8-.7 1.5-1.5 1.5H18.9c-.8 0-1.5-.7-1.5-1.5v-.3c0-.8.7-1.5 1.5-1.5z" opacity=".11" fill="#fff"></path><path d="M122.8 83.5c0 .4.3.8.8.8h10.2c-2.1-.6-4.1-1.6-5.9-2.9-2-1.5-4.1-3.3-5.1-5.1v7.2z" fill-rule="evenodd" clip-rule="evenodd" fill="#208eff"></path><path d="M142.2 68.3H125c-1.3 0-2.3 1-2.4 2.3V82c0 1.3 1.1 2.3 2.4 2.3h17.3c1.3 0 2.3-1 2.4-2.3 0 0 0 0 0 0V70.6c-.1-1.3-1.2-2.3-2.5-2.3 0 0 0 0 0 0z" fill="none" stroke="#333" stroke-width="1.5"></path><path d="M126.6 72.3l5.5 3.6c.5.3 1 .5 1.5.4.5 0 1.1-.2 1.5-.4l5.5-3.6" fill="none" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path fill="none" stroke="#edf0fa" d="M108.2 151.1h229.7v67.1H108.2zM480.5 151.1H361.8v67.1h118.7v-67.1z"></path><path d="M21.7 104.7h49c5.5 0 10 4.5 10 10s-4.5 10-10 10h-49c-5.5 0-10-4.5-10-10s4.5-10 10-10z" fill-rule="evenodd" clip-rule="evenodd" fill="#3485f5"></path><path d="M29 113.5l-4-4.5c-.3-.3-.8-.3-1.1 0l-4.1 4.4c-.1.1-.1.3 0 .4 0 0 .1.1.2.1h.4c.2 0 .3.1.3.3v4.6c0 .4.3.7.7.8h1.9V117c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1v2.5h1.9c.4 0 .8-.3.8-.8v-4.6c0-.2.1-.3.3-.3h.4c.1 0 .1-.1.1-.3zm-4.7-.4c-.5 0-.9-.4-.9-.8 0-.5.4-.8.9-.8s.9.4.9.8-.4.8-.9.8z" fill-rule="evenodd" clip-rule="evenodd" fill="#fff"></path><path d="M38 118.2v-2.8h3.2v2.8h1.2v-7.1h-1.2v3.2H38v-3.2h-1.2v7.1H38zm8.2.1c1.4 0 2.5-1.2 2.5-2.6 0-1.4-1.2-2.5-2.6-2.5-1.4 0-2.5 1.1-2.5 2.5 0 1.3 1 2.5 2.3 2.5.2.1.2.1.3.1zm0-1c-.8 0-1.5-.6-1.6-1.4 0-.8.6-1.5 1.4-1.6.8 0 1.5.6 1.6 1.4v.1c.1.8-.5 1.4-1.4 1.5.1 0 0 0 0 0zm4.9.9v-2.4c0-1 .5-1.5 1.2-1.5s1 .5 1 1.4v2.5h1.1v-2.4c0-1 .5-1.5 1.1-1.5s1 .5 1 1.4v2.5h1.1v-2.8c0-1.5-.6-2.1-1.7-2.1-.7 0-1.3.3-1.8.8-.3-.5-.9-.9-1.5-.8-.6 0-1.1.3-1.5.7v-.7H50v4.9h1.1zm10.1.1c.8.1 1.6-.3 2.1-.9l-.8-.7c-.3.4-.8.6-1.2.6-.7.1-1.3-.4-1.4-1.1h3.6v-.4c.1-1.3-.8-2.3-2.1-2.4h-.2c-1.3 0-2.4 1-2.5 2.3v.2c-.1 1.3 1 2.4 2.3 2.5 0-.1.1-.1.2-.1zm1.1-3h-2.5c.1-.6.7-1 1.3-1 .5 0 1 .4 1.2 1z" fill="#fff"></path>
                                                                        </svg>
                                                                    </DropdownItem>
                                                                </DropdownMenu>
                                                            </Dropdown>
                                                        </div>
                                                    </p>
                                                </div>
                                                <div className='col-10 mt-2'>
                                                    <FormGroup id='note' label='Enter Banner Message'>
                                                        <Textarea
                                                            rows={5}
                                                            placeholder=''
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className='col-11 mt-4'>
                                                    <h5>Select till when this message must be displayed in the portal </h5>
                                                </div>
                                                <div className='col-10 mt-2'>
                                                    <FormGroup id='fromDate' label=''>
                                                        <Input
                                                            aria-placeholder=''
                                                            autoComplete=''
                                                            onChange={employeePortalForm.handleChange}
                                                            onBlur={employeePortalForm.handleBlur}
                                                            value={employeePortalForm.values.fromDate}
                                                            isValid={employeePortalForm.isValid}
                                                            isTouched={employeePortalForm.touched.fromDate}
                                                            invalidFeedback={employeePortalForm.errors.fromDate}
                                                            type='date'
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </>
                                            : null}
                                        <CardFooter>
                                            <CardFooterRight>
                                                <Button
                                                    type='submit'
                                                    color='info'
                                                >
                                                    Save
                                                </Button>
                                            </CardFooterRight>
                                        </CardFooter>
                                    </div>
                                </CardBody>
                            </Card>
                        )}

                        {/* FBP Preference */}

                        {TABS.Flexible_Benefit_Plan === activeTab && (
                            <Card stretch>
                                <CardHeader borderSize={1}>
                                    <CardLabel >
                                        <CardTitle tag='div' className='h4'>
                                            FBP Preference
                                        </CardTitle>
                                    </CardLabel>
                                </CardHeader>
                                <CardBody className='pb-0' isScrollable>
                                    <div className='row g-0'>
                                    </div>
                                    <div className="col-12 d-flex justify-content-center">
                                        <img src="https://css.zohostatic.in/zfpayroll/zpayroll//assets/images/no-active-fbp-component-9be8f0b42e7582ec1322c5b03074bc4d.svg"
                                            width={200} height={200} />
                                    </div>
                                    <div className='row d-flex align-items-center h-50'>
                                        <div className='col-12 d-flex flex-column justify-content-center align-items-center'>
                                            <div className='h4 fw-bold'>
                                                <p >No Active FBP component</p>
                                            </div>
                                            <div className="text-dark">
                                                <p>Your organisation does not have an active FBP component associated to an employee. Mark a reimbursement as FBP component under Settings {'>'} Salary Components{'>'} Reimbursements and associate it to the employee's salary.</p>

                                            </div>
                                            {/* <div className='col-12 d-flex align-items-baseline justify-content-center'>
                                            </div> */}
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        )}

                        {/* //reimbursement page */}

                        {TABS.Reimbursement_Claims === activeTab && (
                            <Card stretch>
                                <CardHeader borderSize={1}>
                                    <CardLabel>
                                        <CardTitle tag='div' className='h4'>
                                            Reimbursement Claims Preference
                                        </CardTitle>
                                    </CardLabel>
                                </CardHeader>
                                <CardBody className='pb-0' isScrollable>
                                    <div className='row g-2'>
                                    </div>
                                    <div className="col-12 d-flex justify-content-center">
                                        <img src="https://css.zohostatic.in/zfpayroll/zpayroll//assets/images/preferences-locked-a1ee0e6ffe4406b1f990c5619226d47a.svg" width={200} height={200} />
                                    </div>
                                    <div className='row d-flex align-items-center h-50'>
                                        <div className='col-12 d-flex flex-column justify-content-center align-items-center'>
                                            <div className='h4 fw-bold'>
                                                <p>No Active Reimbursement</p>
                                            </div>
                                            <div
                                                className='text-dark'>
                                                <p>Employees can get tax exemptions on producing necessary bills. You can enable a reimbursement component under Settings {'>'} Salary Components{'>'} Reimbursements and associate it to the employee's salary.
                                                </p>
                                            </div>
                                            <div className='col-12 d-flex align-items-baseline justify-content-center'>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        )}

                        {/* IT Declaratiom Preference */}

                        {TABS.Income_Tax_Declaration === activeTab && (
                            <Card stretch >
                                <CardHeader borderSize={1}>
                                    <CardLabel>
                                        <CardTitle tag='div' className='h4'>
                                            IT Declaration Preference
                                        </CardTitle>
                                    </CardLabel>
                                </CardHeader>
                                {itDeclaration ?
                                    <CardBody className='pb-0' isScrollable>
                                        <div className="row">
                                            <div className="row">
                                                <div className="col-9">
                                                    <span>Allow employees to submit IT Declaration through  the employee portal and lock on the selected date
                                                    </span>
                                                </div>
                                                <div className='col-3 text-end'>
                                                    <FormGroup>
                                                        <div className='col-10 mt-2'>
                                                            <FormGroup id='fromDate' label=''>
                                                                <Input
                                                                    aria-placeholder=''
                                                                    autoComplete=''
                                                                    onChange={employeePortalForm.handleChange}
                                                                    onBlur={employeePortalForm.handleBlur}
                                                                    value={employeePortalForm.values.fromDate}
                                                                    isValid={employeePortalForm.isValid}
                                                                    isTouched={employeePortalForm.touched.fromDate}
                                                                    invalidFeedback={employeePortalForm.errors.fromDate}
                                                                    type='date'
                                                                />
                                                            </FormGroup>
                                                        </div>
                                                    </FormGroup>
                                                </div>
                                            </div>
                                            <div className="col-12 mt-2">
                                                <Icon
                                                    icon='Alarm'
                                                    size='2x'
                                                    color='dark'
                                                />
                                                <span className='h5'>
                                                    Manage alerts for Employees
                                                </span>
                                            </div>
                                            <div className="col-12 mt-2">
                                                <p>Let employer send mail notifications and reminders automatically based on the configured lock date.</p>
                                            </div>
                                            <div className="col-12 mt-1">
                                                <Checks
                                                    id='flexCheckChecked'
                                                    label='Notify when IT Declaration is RELEASED'
                                                    name='checkedCheck'
                                                    onChange={perferenceCheck}
                                                    checked={perferenceChecked}
                                                />
                                            </div>
                                            <div className="col-12 mt-3">
                                                <Checks
                                                    id='flexCheckChecked'
                                                    label='Enable e-mail reminder to employees to submit before lock date'
                                                    name='checkedCheck'
                                                    onChange={CheckBox}
                                                    checked={itCheckBox}
                                                />
                                            </div>

                                            <div className="col-12 ms-3 mt-4" >
                                                <Badge color='light'>
                                                    <Icon icon='info' color='danger' size='lg' />
                                                    <span className='h6 text-dark'>
                                                        You are currently in the Free Plan. To configure IT Declaration lock date reminders, upgrade your plan.
                                                    </span>
                                                </Badge>
                                            </div>
                                            <div className="col-12 mt-4">
                                                <Checks
                                                    id='flexCheckChecked'
                                                    label='Notify when IT Declaration is LOCKED'
                                                    name='checkedCheck'
                                                    onChange={byInCheck}
                                                    checked={bycheck}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 mt-1 d-flex justify-content-center">
                                            <Button type='submit' color='light' isOutline onClick={() => setItDeclaration(!itDeclaration)}>
                                                Lock It Declaration </Button>
                                        </div>
                                    </CardBody>
                                    :
                                    <CardBody className='pb-0' isScrollable>
                                        <div className="row">
                                            <div className='col-12'>
                                                <p>Employees can declare their tax saving investments and expense details through
                                                    the employee portal once you enable this option.
                                                </p>
                                            </div>
                                            <div className='col-12'>
                                                <Icon
                                                    icon='lightbulb'
                                                    size='lg'
                                                    color='primary'
                                                />
                                                <span> Learn how to manage investment declarations.</span>
                                                <span className='text-primary gap-3 align-self-center' >
                                                    <a href="https://www.zoho.com/in/payroll/help/employer/it-declaration.html" target="_blank" rel="noopener noreferrer">IT Declaration Help Document</a>
                                                </span>
                                            </div>
                                            <div className='col-12 mt-2'>
                                                <p>Help your employees submit IT Declaration on time.
                                                    <span className='text-primary'>  Download and share
                                                    </span>
                                                    this IT Declaration ebook.
                                                </p>
                                            </div>
                                            <div className='col-12 mt-2'>
                                                <Card borderSize={2}>
                                                    <CardBody>
                                                        <div className="row">
                                                            <div className="col-12 d-flex justify-content-center">
                                                                <img src="https://css.zohostatic.in/zfpayroll/zpayroll//assets/images/preferences-locked-a1ee0e6ffe4406b1f990c5619226d47a.svg" width={150} height={150} />

                                                            </div>
                                                            <div className='col-12 h4 mt-4 d-flex justify-content-center'>
                                                                IT Declaration is Locked
                                                            </div>
                                                            <div
                                                                className='col-12 d-flex justify-content-center'>
                                                                <p> You are yet to enable the submission of IT Declaration for your employees through their respective portals. Release IT Declaration or submit it on their behalf under Employees {'>'} Employee profile {'>'} Investments {'>'} IT Declaration.
                                                                </p  >
                                                            </div>
                                                            <div className='col-12 h4 mt-1 d-flex justify-content-center'
                                                                onClick={() => setItDeclaration(!itDeclaration)}>
                                                                <Button type='submit' color='brand-two' rounded={1}
                                                                    isOutline
                                                                >
                                                                    Release IT Declaration
                                                                </Button>
                                                            </div> <hr />
                                                            <div className='col-12 h4'>
                                                                Other Configurations
                                                            </div>
                                                            <div className="col-12 mt-2">
                                                                <Checks
                                                                    id='flexCheckChecked'
                                                                    label='Allow employees to switch tax regimes'
                                                                    name='checkedCheck'
                                                                    onChange={addCheck}
                                                                    checked={andchecked}
                                                                />
                                                            </div>
                                                            <div className='col-12 h4 mt-4'>
                                                                <Button type='submit' color='info' rounded={1}
                                                                >
                                                                    Save
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </div>
                                    </CardBody>
                                }
                            </Card>

                        )}

                        {/* POI preference */}

                        {TABS.Proof_Of_Investments === activeTab && (
                            <Card stretch>
                                <CardHeader borderSize={1}>
                                    <CardLabel>
                                        <CardTitle tag='div' className='h4'>
                                            POI Preference
                                        </CardTitle>
                                    </CardLabel>
                                </CardHeader>
                                {poiPreference ?
                                    <CardBody className='pb-0' isScrollable>
                                        <div className="row">
                                            <div className="col-9">
                                                <span>Allow employees to submit POI through the employee portal and lock on the selected date
                                                </span>
                                            </div>
                                            <div className='col- 3  text-end'>
                                                <FormGroup>
                                                    <div className='col-10 mt-2'>
                                                        <FormGroup id='fromDate' label=''>
                                                            <Input
                                                                aria-placeholder=''
                                                                autoComplete=''
                                                                onChange={employeePortalForm.handleChange}
                                                                onBlur={employeePortalForm.handleBlur}
                                                                value={employeePortalForm.values.fromDate}
                                                                isValid={employeePortalForm.isValid}
                                                                isTouched={employeePortalForm.touched.fromDate}
                                                                invalidFeedback={employeePortalForm.errors.fromDate}
                                                                type='date'
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                </FormGroup>
                                            </div>
                                        </div>
                                        <div className="col-12 mt-2">
                                            <Icon
                                                icon='Alarm '
                                                size='2x'
                                                color='dark'
                                            />
                                            <span className='h5 mt-1'>
                                                Manage alerts for Employees
                                            </span>
                                        </div>
                                        <div className="col-12 mt-2">
                                            <p>Let employer send mail notifications and reminders automatically based on the configured lock date.</p>
                                        </div>
                                        <ChecksGroup>
                                            <div className="col-12 mt-2 ">
                                                <Checks
                                                    id='flexCheckChecked'
                                                    label='Notify when POI Submission is RELEASED'
                                                    name='checkedCheck'
                                                    onChange={poiChecked}
                                                    checked={poichecked}
                                                />
                                            </div>

                                            <div className="col-12 mt-3">
                                                <Checks
                                                    id='flexCheckChecked'
                                                    label=' Enable e-mail reminder to employees to submit before lock date'
                                                    name='checkedCheck'
                                                    onChange={itChecked}
                                                    checked={itchecked}
                                                />
                                            </div><br />
                                            <div className="col-12 ms-3">
                                                <Badge color='light'>
                                                    <Icon icon='info' color='danger' size='lg' />
                                                    <span className='h6 text-dark'>
                                                        You are currently in the Free Plan. To configure POI lock date reminders, upgrade your plan.
                                                    </span>
                                                </Badge>
                                            </div>
                                            <div className="col-12 mt-3">
                                                <Checks
                                                    type='checkbox'
                                                    id='exampleInlineOne'
                                                    label=' Notify when POI Submission is LOCKED'
                                                    onChange={poiItChecked}
                                                    checked={poiItchecked}
                                                />
                                            </div>
                                        </ChecksGroup>
                                        <div className="col-12 mt-2 d-flex justify-content-center">
                                            <Button type='submit' color='light' isOutline onClick={() => setPoiPreference(!poiPreference)}>
                                                Lock Proof Of Investment
                                            </Button>
                                        </div>
                                    </CardBody>
                                    :
                                    <CardBody className='pb-0' isScrollable>
                                        <div className="row">
                                            <div className='col-12 h'>
                                                <p>Employees can submit the necessary supporting documents for their declared investments through the employee portal once you enable this option.
                                                </p>
                                            </div>
                                            <div className="col-12">
                                                <Icon
                                                    icon='lightbulb'
                                                    size='lg'
                                                    color='primary'
                                                />
                                                <span>Learn how to manage investment declarations.</span>
                                                <span className=' text-primary align-self-center'> <a href="https://www.zoho.com/in/payroll/help/employer/poi.html" target="_blank" rel="noopener noreferrer"> IT Declaration Help Document</a></span>
                                            </div>
                                            <div className="col-12 mt-2">
                                                <div className='col-12 mt-2'>
                                                    <p>Help your employees submit POI on time.
                                                        <span className='text-primary'>  Download and share  </span>
                                                        this POI ebook.
                                                    </p>
                                                </div>
                                                <Card borderSize={2}>
                                                    <CardBody>
                                                        <div className='col-12 d-flex justify-content-center'>
                                                            <img src="https://css.zohostatic.in/zfpayroll/zpayroll//assets/images/preferences-locked-a1ee0e6ffe4406b1f990c5619226d47a.svg" width={150} height={150} />
                                                        </div>
                                                        <div className="col-12 d-flex 
                                                       justify-content-center h4 mt-3">
                                                            POI is Locked
                                                        </div>
                                                        <div className="col-12 d-flex justify-content-center mt-3 ">
                                                            You are yet to enable submission of investment proofs for your
                                                            employees through their respective portals
                                                            Release POI or submit it on their behalf under
                                                            Employees {'>'} Employee profile {'>'} Investments {'>'}
                                                            Proof of Investments.
                                                        </div>
                                                        <div className='col-12 h4 mt-4 d-flex justify-content-center'>
                                                            <Button type='submit' color='brand-two' rounded={1}
                                                                isOutline onClick={() => setPoiPreference(!poiPreference)}
                                                            >
                                                                Release Proof Of Invesments
                                                            </Button>
                                                        </div> <hr />
                                                        <div className="col-12 mt-4 fw-bold h5">
                                                            Process payroll with approved POI amount from
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-9 mt-3">
                                                                <span className='text-primary'>
                                                                    The approved POI amount will be considered for the payroll from March onwards to calculate and deduct income tax amount in subsequent payrolls.
                                                                </span>
                                                            </div>

                                                            <div className='col-3 mt-3'>
                                                                <FormGroup >
                                                                    <Select
                                                                        ariaLabel=''
                                                                        placeholder=''
                                                                        list={[
                                                                            { value: 'January', text: 'January' },
                                                                            { value: 'February', text: 'February' },
                                                                            { value: 'March', text: 'March' },
                                                                            { value: 'April', text: 'April' },
                                                                            { value: 'May', text: 'May' },
                                                                            { value: 'June', text: 'June' },
                                                                            { value: 'July', text: 'July' },
                                                                            { value: 'August', text: 'August' },
                                                                            { value: 'September', text: 'September' },
                                                                            { value: 'October', text: 'October' },
                                                                            { value: 'November', text: 'November' },
                                                                            { value: 'December', text: 'December' },
                                                                        ]}
                                                                    />
                                                                </FormGroup>
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <div className="col-12 h4 mt-2">
                                                            Other Configurations
                                                        </div>
                                                        <div className="col-12 mt-3">
                                                            <Checks
                                                                id='flexCheckChecked'
                                                                label='Allow employees to switch tax regimes'
                                                                name='checkedCheck'
                                                                onChange={dooCheck}
                                                                checked={dooChecked}
                                                            />
                                                        </div>
                                                        <div className="col-12 mt-3">
                                                            <Checks
                                                                id='flexCheckChecked'
                                                                label=' Mandate investment proof attachments for POI submission'
                                                                name='checkedCheck'
                                                                onChange={Checked}
                                                                checked={checked}
                                                            />
                                                        </div>

                                                        <div className="col-12 mt-3">
                                                            <Checks
                                                                id='flexCheckChecked'
                                                                label='Mandate reviewer comments for partial investment amount approval'
                                                                onChange={byCheck}
                                                                checked={bychecked}
                                                            />
                                                        </div>
                                                        <div className='col-12 h4 mt-4'>
                                                            <Button
                                                                type='submit'
                                                                color='info'
                                                                rounded={1}
                                                            >
                                                                Save
                                                            </Button>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </div>
                                    </CardBody>
                                }
                            </Card>
                        )}

                        {/* employee */}

                        {TABS.Employee === activeTab && (
                            <Card stretch>
                                <CardHeader borderSize={1}>
                                    <CardLabel>
                                        <CardTitle tag='div' className='h4'>
                                            Employee
                                        </CardTitle>
                                    </CardLabel>
                                    <CardActions>
                                        <span className='h6 text-primary'>
                                            Custom Fields Usage: 0/46
                                        </span>
                                        <Button
                                            type='submit'
                                            color='info'
                                            rounded={0}
                                            onClick={() => setCreate(!create)}
                                        >
                                            Create New
                                        </Button>
                                    </CardActions>
                                </CardHeader>
                                <CardBody>
                                    <div className='col-12 h4 '>
                                        Custom Field
                                    </div>
                                    <div className='row d-flex align-items-center h-100'>
                                        <div className='col-xl-6'>
                                            <div className='col-12 mt-1'>
                                                <img src="https://css.zohostatic.in/zfpayroll/zpayroll//assets/images/empty-states/upgrade-plan-2d72eaae6f63dc78acf75acd08f95777.svg"
                                                    width={240} height={240} />
                                            </div>
                                            <div className='col-12 h5'>
                                                This feature is unavailable in your plan
                                            </div>
                                            <div className='col-12 mt-4 h6'>
                                                Would you like to switch to a higher plan?
                                            </div>
                                            <div className="col-12 mt-4 ms-5 d-flex align-items-center">
                                                <Button
                                                    type='submit'
                                                    color='info'
                                                    rounded={0}
                                                >
                                                    Upgrade Now
                                                </Button>
                                            </div>
                                        </div>
                                        <div className='col-xl-5'>
                                            <div className='row'>
                                                <div className='col-12 ms-3 d-flex align-items-center'>
                                                    <span className='h5 mt-1'>
                                                        With this feature you can
                                                    </span>
                                                </div>
                                                <div className='col-12 ms-4 mt-2 d-flex align-items-center'>
                                                    <Icon icon='Check' color='success' size='lg' />
                                                    Include additional employee details
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                                <br />
                            </Card>

                        )}

                        {/*Sender Email Preference */}

                        {TABS.Sender_Email_Preference === activeTab && (
                            <Card stretch>
                                <CardHeader borderSize={1}>
                                    <CardLabel>
                                        <CardTitle tag='div' className='h4'>
                                            Sender Email Preference
                                        </CardTitle>
                                    </CardLabel>
                                    <CardActions>
                                        <Button
                                            type='submit'
                                            color='info'
                                            rounded={1}
                                            onClick={() => setAddSender(!addSender)}
                                        >
                                            Add Sender
                                        </Button>
                                    </CardActions>
                                </CardHeader>
                                <CardBody isScrollable>
                                    <div className='h6 ms-4'>Public Domains
                                        <Tooltips title='Public Domains include free email service providers such as Gmail,Yahoo,Outlook,etc.' placement='right'>
                                            <Button icon="Info" />
                                        </Tooltips>
                                    </div>

                                    <div className='row g-4'>
                                        <Card borderSize={1}>
                                            <CardBody>
                                                <div className="row g-4">
                                                    <div className='col-lg-4 mt-2'>
                                                        <CardTitle>
                                                            <small className='text-muted fs-6'>
                                                                EMAILS ARE SENT THROUGH
                                                            </small>
                                                            <br /><br /><p className='text-muted fs-6'>Email address of Zoho Payroll</p>
                                                            <small className='text-muted fs-6'>(message-service@mail.zohopayroll.in)</small>
                                                        </CardTitle>
                                                    </div>

                                                    <div className='col-8'>
                                                        <Alert
                                                            color='warning'
                                                            shadow='sm'
                                                            isLight
                                                        >
                                                            <div className="h6 ">
                                                                <Icon icon="info" color="danger" size="sm" />&nbsp;
                                                                If you send emails from public domain, they are likely to land in the Spam folder.  So, if emails are  sent with any of the following email addresses in the From field, emails will be sent from message-service@mail.zohopayroll.in. If you still want to send emails using the public domain,
                                                                <Button
                                                                    isLink
                                                                    color="info"
                                                                    onClick={() => setEmailContentOpen(true)}>
                                                                    <span className="text-info">  Change Setting</span>
                                                                </Button>
                                                            </div>
                                                        </Alert>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                        <Card>
                                            <CardBody>
                                                <div className="row">
                                                    <div className='col-4 h6'>
                                                        NAME
                                                    </div>
                                                    <div className='col-5 h6' >
                                                        <div className='flex-shrink-0'>
                                                            EMAIL ADDRESS
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr />
                                                {emailPreference ?
                                                    <>
                                                        <div className="row mt-2">
                                                            <div className="col-8">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <FormGroup id='name' label='Name' isFloating>
                                                                            <Input
                                                                                aria-placeholder=''
                                                                                autoComplete=''
                                                                                onChange={employeePortalForm.handleChange}
                                                                                onBlur={employeePortalForm.handleBlur}
                                                                                value={employeePortalForm.values.name}
                                                                                isValid={employeePortalForm.isValid}
                                                                                isTouched={employeePortalForm.touched.name}
                                                                                invalidFeedback={employeePortalForm.errors.name}
                                                                            />
                                                                        </FormGroup>

                                                                    </div>
                                                                    <div className="col-6" >
                                                                        <FormGroup id='email' label='Email' isFloating>
                                                                            <Input
                                                                                aria-placeholder=''
                                                                                autoComplete=''
                                                                                onChange={employeePortalForm.handleChange}
                                                                                onBlur={employeePortalForm.handleBlur}
                                                                                value={employeePortalForm.values.email}
                                                                                isValid={employeePortalForm.isValid}
                                                                                isTouched={employeePortalForm.touched.email}
                                                                                invalidFeedback={employeePortalForm.errors.email}
                                                                            />
                                                                        </FormGroup>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-4 mt-2">
                                                                <Button type='submit' icon='Save' color='info'>Save</Button>
                                                                &nbsp;
                                                                <Button type='submit' color='light' isOutline onClick={() => setEmailPreference(!emailPreference)}
                                                                >Cancel</Button>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className="row mt-2">
                                                            <div className="col-9">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <FormGroup id='name' label="Name" isFloating>
                                                                            <Input
                                                                                aria-placeholder=''
                                                                                autoComplete=''
                                                                                onChange={employeePortalForm.handleChange}
                                                                                onBlur={employeePortalForm.handleBlur}
                                                                                value={employeePortalForm.values.name}
                                                                                isValid={employeePortalForm.isValid}
                                                                                isTouched={employeePortalForm.touched.name}
                                                                                invalidFeedback={employeePortalForm.errors.name}
                                                                            />
                                                                            {/* <Badge color='success' rounded={0}>PRIMARY</Badge> */}
                                                                        </FormGroup>
                                                                    </div>
                                                                    <div className="col-6" >
                                                                        <FormGroup id='email' label='Email' isFloating>
                                                                            <Input
                                                                                aria-placeholder=''
                                                                                autoComplete=''
                                                                                onChange={employeePortalForm.handleChange}
                                                                                onBlur={employeePortalForm.handleBlur}
                                                                                value={employeePortalForm.values.email}
                                                                                isValid={employeePortalForm.isValid}
                                                                                isTouched={employeePortalForm.touched.email}
                                                                                invalidFeedback={employeePortalForm.errors.email}
                                                                            />
                                                                        </FormGroup>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-3 mt-2">
                                                                <Button type='submit' icon='edit' color='dark' isOutline onClick={() => setEmailPreference(!emailPreference)}></Button>
                                                                &nbsp;
                                                                <Button type='submit' icon='delete' color='dark' isOutline
                                                                ></Button>
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </CardBody>
                                        </Card>
                                    </div>
                                </CardBody>
                            </Card>
                        )}

                        {/* employee portal MANAGE CONTACTS pop-up*/}

                        <Modal
                            setIsOpen={setManageContactsOpen}
                            isOpen={manageContactsOpen}
                            titleId='upcomingEdit'
                            isScrollable
                            size='lg'>
                            <ModalHeader setIsOpen={setManageContactsOpen}>
                                <ModalTitle id='exampleModalLabel'>Portal Contacts</ModalTitle>
                            </ModalHeader>
                            <ModalBody>
                                <div>CONTACT INFORMATION</div>
                                <hr />
                                {contactEdit ?
                                    <div className="row">
                                        <div className="col-9 mt-2">
                                            <div className="row">
                                                <div className="col-6 mt-2">
                                                    <FormGroup id='name' label='Name' isFloating>
                                                        <Input
                                                            aria-placeholder=''
                                                            autoComplete=''
                                                            onChange={employeePortalForm.handleChange}
                                                            onBlur={employeePortalForm.handleBlur}
                                                            value={employeePortalForm.values.name}
                                                            isValid={employeePortalForm.isValid}
                                                            isTouched={employeePortalForm.touched.name}
                                                            invalidFeedback={employeePortalForm.errors.name}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-6 mt-2" >
                                                    <FormGroup id='email' label='Email' isFloating>
                                                        <Input
                                                            aria-placeholder=''
                                                            autoComplete=''
                                                            onChange={employeePortalForm.handleChange}
                                                            onBlur={employeePortalForm.handleBlur}
                                                            value={employeePortalForm.values.email}
                                                            isValid={employeePortalForm.isValid}
                                                            isTouched={employeePortalForm.touched.email}
                                                            invalidFeedback={employeePortalForm.errors.email}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-3 mt-4">
                                            <Button type='submit' icon='Save' color='info'>Save</Button>
                                            &nbsp;
                                            <Button type='submit' color='light' isOutline onClick={() => setContactEdit(!contactEdit)}
                                            >Cancel</Button>
                                        </div>
                                    </div>
                                    : <>
                                        <div className="row">
                                            <div className="col-10 mt-2" >
                                                <div className='h5 fw-bold '>
                                                    snehajoe16291
                                                    <Badge
                                                        isLight
                                                        color='danger'
                                                        className='px-3 ms-3 py-2'>
                                                        SHOWN IN PORTAL
                                                    </Badge>
                                                </div>

                                                <div className='h6 text-muted'>snehajoe16291@gmail.com
                                                </div>
                                            </div>
                                            <div className="col-2 mt-3">
                                                <Button isOutline={!darkModeStatus} color='dark' isLight={darkModeStatus} className={classNames('text-nowrap', {
                                                    'border-light': !darkModeStatus,
                                                })} icon='Edit' onClick={() => setContactEdit(!contactEdit)}>
                                                    Edit
                                                </Button>
                                            </div>
                                        </div>
                                    </>}
                                <br />
                                <br />
                                {/* <hr /> */}
                                <br />
                                {handleEdit ?

                                    <div className="row mt-2">
                                        <div className="col-9 mt-2">
                                            <div className="row">
                                                <div className="col-6 mt-2">
                                                    <FormGroup id='name' label='Name' isFloating>
                                                        <Input
                                                            aria-placeholder=''
                                                            autoComplete=''
                                                            onChange={employeePortalForm.handleChange}
                                                            onBlur={employeePortalForm.handleBlur}
                                                            value={employeePortalForm.values.name}
                                                            isValid={employeePortalForm.isValid}
                                                            isTouched={employeePortalForm.touched.name}
                                                            invalidFeedback={employeePortalForm.errors.name}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-6 mt-2">
                                                    <FormGroup id='email' label='Email' isFloating>
                                                        <Input
                                                            aria-placeholder=''
                                                            autoComplete=''
                                                            onChange={employeePortalForm.handleChange}
                                                            onBlur={employeePortalForm.handleBlur}
                                                            value={employeePortalForm.values.email}
                                                            isValid={employeePortalForm.isValid}
                                                            isTouched={employeePortalForm.touched.email}
                                                            invalidFeedback={employeePortalForm.errors.email}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-3 mt-4">
                                            <Button type='submit' icon='Save' color='info'>Save</Button>
                                            &nbsp;
                                            <Button type='submit' color='light' isOutline onClick={() => setHandleEdit(!handleEdit)}
                                            >Cancel</Button>
                                        </div>
                                    </div>
                                    : <>
                                        <div className="row mt-3">
                                            <div className="col-2 mt-2">
                                                <Button isOutline={!darkModeStatus} color='info' isLight={darkModeStatus} className={classNames('text-nowrap', {
                                                    'border-light': !darkModeStatus,
                                                })} icon='Add' onClick={() => setHandleEdit(!handleEdit)}>
                                                    Add Contact
                                                </Button>
                                            </div>
                                        </div>

                                    </>}
                            </ModalBody>
                            <br />
                            <br />
                        </Modal>

                        {/* sender email preference CHANGE SETTING pop_up open */}

                        <Modal
                            setIsOpen={setEmailContentOpen}
                            isOpen={emailContentOpen}
                            titleId='upcomingEdit'
                            size='lg'>
                            <ModalHeader setIsOpen={setEmailContentOpen}>
                                <ModalTitle id='examplemailcontent'>
                                    <div className="h4">Emails Are Sent Through
                                    </div>
                                </ModalTitle>
                            </ModalHeader><hr />
                            <ModalBody>
                                <Card borderColor={radioButtonChecked1 == 'first' ? "primary" : null} borderSize={radioButtonChecked1 == 'first' ? 1 : 0}>
                                    <div className="row">
                                        <div className='d-flex justify-content-center col-5 h5 fw-bold mt-3'>
                                            <Checks
                                                type='radio'
                                                name='flexRadioDefault'
                                                id='flexRadioDefault1'
                                                label='Email address of Zoho Payroll'
                                                value='first'
                                                onChange={() => setRadioButtonChecked1("first")}
                                                checked={radioButtonChecked1}
                                            />
                                        </div>
                                        <div className='col-1 h5 fw-bold mt-3'>
                                            <Badge
                                                isLight
                                                color='warning'
                                                className='px-3 py-2'
                                            >
                                                RECOMMENDED
                                            </Badge>
                                        </div>
                                        <div className="col-12 ms-4 mt-2">
                                            <div className='h6 text-muted'>
                                                (message-service@mail.zohopayroll.in)
                                            </div>
                                            <div className="h6 mt-3">All the emails sent to customers will have message-service@mail.zohopayroll.in in the From field. But the reply-to email address will be primary contact's email address, snehajoe16291@gmail.com.</div><br />
                                        </div>
                                    </div>
                                </Card>
                                <Card borderColor={radioButtonChecked1 == 'second' ? "primary" : null} borderSize={radioButtonChecked1 == 'second' ? 1 : 0}>
                                    <div className="col-12 ms-4 mt-3">
                                        <div className="col-10">
                                            <div className='h5 fw-bold mt-3'>
                                                <Checks
                                                    type='radio'
                                                    name='flexRadioDefault'
                                                    id='flexRadioDefault2'
                                                    label='Email address of Sender'
                                                    value='second'
                                                    onChange={() => setRadioButtonChecked1("second")}
                                                    checked={radioButtonChecked1}
                                                />
                                            </div>
                                            <div className="h6 mt-3">All the emails sent to customers will have sender's email address in the From field. To prevent emails from landing in the Spam folder, we strongly recommend you to use the email address of Zoho Payroll.</div><br />
                                        </div>
                                    </div>
                                </Card>
                                <div className="col-3 mt-2">
                                    <Button type='submit' color='info'>save</Button>
                                    &nbsp;
                                    <Button type='submit' color='light' isOutline onClick={() => setOnChange(!onChange)}
                                    >Cancel</Button>
                                </div>
                            </ModalBody>
                        </Modal>

                        {/* employee CREATE NEW POP_UP */}

                        <Modal
                            setIsOpen={setCreate}
                            isOpen={create}
                            titleId='upcomingEdit'
                            isScrollable
                            size='lg'>
                            <ModalHeader setIsOpen={setCreate}>
                                <ModalTitle id='examplecreate'>
                                    <div className="row">
                                        <div className="col-12 mt-2 ms-2" >
                                            <Icon icon='Error' color='warning' size='3x' />&nbsp;
                                            <span>
                                                You are currently in the Free Plan. To configure Custom Fields, upgrade your plan.
                                            </span>
                                        </div>
                                    </div>
                                </ModalTitle><hr />
                            </ModalHeader>
                            <ModalBody>
                                <div className="col-3 mt-2">
                                    <Button type='submit' color='info'>Update</Button>
                                    &nbsp;
                                    <Button type='submit' color='light' isOutline
                                    >Cancel</Button>
                                </div>
                            </ModalBody>
                        </Modal>

                        {/* sender email preference ADD SENDER pop up */}

                        <OffCanvas
                            setOpen={setAddSender}
                            isOpen={addSender}
                            titleId='upcomingEdit'
                            placement='end'>
                            <OffCanvasHeader setOpen={setAddSender}>
                                <OffCanvasTitle id='exampleaddsender'>
                                    Add Sender
                                </OffCanvasTitle>
                            </OffCanvasHeader>
                            <OffCanvasBody>
                                <div className="row gap-4">
                                    <div className="col-12">
                                        <FormGroup id='email' label='Name'>
                                            <Input
                                                aria-placeholder=''
                                                autoComplete=''
                                                onChange={employeePortalForm.handleChange}
                                                onBlur={employeePortalForm.handleBlur}
                                                value={employeePortalForm.values.name}
                                                isValid={employeePortalForm.isValid}
                                                isTouched={employeePortalForm.touched.name}
                                                invalidFeedback={employeePortalForm.errors.name}
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-12" >
                                        <FormGroup id='emil' label='Email'>
                                            <Input
                                                aria-placeholder=''
                                                autoComplete=''
                                                onChange={employeePortalForm.handleChange}
                                                onBlur={employeePortalForm.handleBlur}
                                                value={employeePortalForm.values.email}
                                                isValid={employeePortalForm.isValid}
                                                isTouched={employeePortalForm.touched.email}
                                                invalidFeedback={employeePortalForm.errors.email}
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                            </OffCanvasBody>
                            <div className='row m-0'>
                                <div className='col-12 p-3'>
                                    <Button type='submit' className='w-100' icon='Save' color='info'>Save</Button>
                                </div>
                            </div>
                        </OffCanvas>

                    </div >
                </div >
            </Page >
        </PageWrapper >
    );
}
export default emailPreferences;